var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0C10.084 0 13 2.916 13 6.5S10.084 13 6.5 13A6.508 6.508 0 010 6.5C0 2.916 2.916 0 6.5 0zm0 12.458A5.965 5.965 0 0012.458 6.5 5.965 5.965 0 006.5.542 5.965 5.965 0 00.542 6.5 5.965 5.965 0 006.5 12.458z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23 4.875h.54V9.75h-.54V4.875zm0-1.625h.54v.542h-.54V3.25z",
    fill: "#000"
  })));
};

export default SvgInfo;